import React from "react";
import SysAppLoggerDetails from "../component/SysAppLoggerDetails";

const SysAppLoggerDetailsContainer = (pageId) => (<SysAppLoggerDetails pageId={ pageId } />)

export default SysAppLoggerDetailsContainer;
